
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
    InvestorMonthlyCutFactory
} from './Factories';
import {
    MonthlyCutCustomService, InvestorCustomActionsService, PaginationService
} from '../_services';
import { InvestorMonthlyCut as T, Serialized } from './Interfaces';
import { InvestorMonthlyCut as C, MonthlyCut, Page } from './Classes';

@Injectable()
export class InvestorMonthlyCut {
    collection: C[] = [];
    item: C;
    changed$: Subject<C> = new Subject<C>();
    page: Page = new Page();
    constructor(
        private factory: InvestorMonthlyCutFactory,
        private main: MonthlyCutCustomService,
        private iMain: InvestorCustomActionsService,
        private paging: PaginationService
    ) {
        if (!this.item) this.make({});
    }
    empty() {
        return !this.item.id;
    }
    get instance() {
        return this.item;
    }
    set instance(value) {
        this.item = value;
        this.changed$.next(this.item);
    }
    isInstance(test) {
        return test instanceof C;
    }
    make(json) {
        this.item = this.factory.createInstance(json);
        this.changed$.next(this.item);
        return this.item;
    }

    getAll(parentId: number, params?: string): Observable<C[]> {
        return this.main.getMonthlyCutForInvestors(parentId, params)
            .map((response: Serialized) => {
                this.assignPageAndCollection(
                    response.meta.pagination, response.data);
                return this.collection;
            });
    }
    getInvestorMonthlyCuts(id: number, params?: string) {
        return this.iMain.getMonthlyCuts(id, params).map((response: Serialized) => {
            this.assignPageAndCollection(
                response.meta.pagination, response.data);
            return this.collection;
        });
    }
    uploadInvoice(files: [File, File]) {
        let body: FormData = new FormData();
        body.set('xml_file', files[0]);
        body.set('pdf_file', files[1]);
        return this.iMain.uploadInvoice(this.item.investor.id, this.item.id, body)
            .map((response: Serialized) => {
                return response;
            });
    }
    nextPage(next: number, params?: string) {
        return this.paging.next(this.page, params).map((response: Serialized) => {
            this.assignPageAndCollection(
                response.meta.pagination, response.data);
            return response;
        });
    }
    prevPage(prev: number, params?: string) {
        return this.paging.prev(this.page, params).map((response: Serialized) => {
            this.assignPageAndCollection(
                response.meta.pagination, response.data);
            return response;
        });
    }
    withinPageLimit(next: number) {
        return next < this.page.total_pages;
    }
    private assignPageAndCollection(page: Page, monthlyCuts: (T | any)[]) {
        this.collection = this.factory.createInstances(monthlyCuts);
        this.page = new Page(page);
    }
    setPage(page) {
        let goingPage = page.offset + 1;
        let go: any;
        if (this.page.current_page < goingPage && this.withinPageLimit(page.offset))
            go = this.nextPage(goingPage);
        if (this.page.current_page > goingPage && this.withinPageLimit(page.offset))
            go = this.prevPage(goingPage);
        if (go) go.subscribe(response => { });
    }
}

export const InvestorMonthlyCutProviders = [
    MonthlyCutCustomService,
    InvestorCustomActionsService,
    InvestorMonthlyCutFactory,
    PaginationService,
    // This class dependencies
    {
        provide: InvestorMonthlyCut,
        useClass: InvestorMonthlyCut,
        deps: [
            InvestorMonthlyCutFactory, MonthlyCutCustomService, InvestorCustomActionsService,
            PaginationService
        ]
    }
];



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/investor-monthly-cut.ts